var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outPage"},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("按钮")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("按钮")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"}},[_vm._v("按钮")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc654d6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/outPage.vue
// module id = null
// module chunks = 